module.exports = __webpack_public_path__ + "52311ddb827a4f2453a15c996e6991ae.pdf";